import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const TokenMonitor = (props) => {
    const { children, logOut } = props;
    const navigate = useNavigate();

    useEffect(() => {
        const checkTokenIssuedDate = () => {
            const tokenIat = sessionStorage.getItem("iat");
            if (tokenIat) {
                const issuedDate = new Date(parseInt(tokenIat, 10) * 1000); // seconds to ms
                const today = new Date();

                // Zero out time for comparison (YYYY-MM-DD only)
                const issuedDay = new Date(issuedDate.getFullYear(), issuedDate.getMonth(), issuedDate.getDate());
                const currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                if (issuedDay < currentDay) {
                    console.warn("Token issued before today — logging out...");
                    logOut?.();
                }
            }
        };

        checkTokenIssuedDate();

        // Run every 30 minutes
        const intervalId = setInterval(checkTokenIssuedDate, 30 * 60 * 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, [navigate]);

    return children;
};
